/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { UPDATE_ACK_STATUS } from '@pages/PolicyDetailPage/apis/graphql';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateAckMethods extends IPluginMethodMap {
  getUpdateAckStatus(args: any): Promise<any>;
}

export interface UpdateStatusProps {
  id: string;
}

export class UpdateAckPlugin implements IAgentPlugin {
  readonly methods: IUpdateAckMethods;

  constructor() {
    this.methods = {
      getUpdateAckStatus: this.getUpdateAckStatus.bind(this),
    };
  }

  async getUpdateAckStatus(args: UpdateStatusProps) {
    return await this.updateAckStatus(args);
  }

  private async updateAckStatus(args: UpdateStatusProps) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_ACK_STATUS, {
          payoutIds: args,
        })
        .toPromise();

      if (res?.data?.acknowledgePayout) {
        return res?.data?.acknowledgePayout;
      }
    } catch (err: any) {
      throw err;
    }
  }
}
